
<template>
 <!-- 联系我们 -->
 <section class="bg-white py-16 md:py-24" id="contact">
  <div class="container mx-auto px-6">
    <div class="text-center mb-16">
      <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        联系我们
      </h2>
      <div class="w-20 h-1 bg-blue-700 mx-auto mb-6"></div>
      <p class="text-gray-700 max-w-3xl mx-auto">
        无论您有任何问题或需求，我们都随时准备为您提供专业的咨询和服务。
      </p>
    </div>

    
    <div class="flex flex-col lg:flex-row">
      <div class="w-full lg:w-1/2 mb-10 lg:mb-0 lg:pr-10">
        <div class="bg-blue-50 p-8 rounded-lg" b >
          <h3 class="text-2xl font-bold text-gray-800 mb-7">联系方式</h3>
          <div class="space-y-6">
            <div class="flex items-start">
              <div class="flex-shrink-0 mr-4">
                <div
                  class="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center"
                >
                  <i class="fas fa-map-marker-alt text-blue-700"></i>
                </div>
              </div>
              <div>
                <h4 class="text-lg font-semibold text-gray-800 mb-1">
                  公司地址
                </h4>
                <p class="text-gray-600">
                  成都市高新区观东三街158号6栋23层2306号
                </p>
              </div>
            </div>
            
            <div class="flex items-start">
              <div class="flex-shrink-0 mr-4">
                <div
                  class="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center"
                >
                  <i class="fas fa-phone-alt text-blue-700"></i>
                </div>
              </div>
             
              <div>
                <h4 class="text-lg font-semibold text-gray-800 mb-1">
                  联系电话
                </h4>
                <p class="text-gray-600">18583997111,13980710733</p>
              </div>
              
            </div>
             <div class="flex items-start">
              <div class="flex-shrink-0 mr-4">
                <div
                  class="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center"
                >
                  <i class="fas fa-phone-alt text-blue-700"></i>
                </div>
              </div>
             
              <div>
                <h4 class="text-lg font-semibold text-gray-800 mb-1">
                  联系邮箱
                </h4>
                <p class="text-gray-600">Liuj@cnwz-ai.com</p>
              </div>
              
            </div>
         
            <div class="flex items-start">
              <div class="flex-shrink-0 mr-4">
                <div
                  class="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center"
                >
                  <i class="fas fa-clock text-blue-700"></i>
                </div>
              </div>
              <div>
                <h4 class="text-lg font-semibold text-gray-800 mb-1">
                  工作时间
                </h4>
                <p class="text-gray-600">周一至周五: 9:00 - 18:00</p>
              </div>
            </div>

            
          </div>
          
        </div>
      </div>

      <div class="w-full lg:w-1/2">
          <img src="../assets/addressus.png"/>
      </div>
     </div> 


</div>



</section>
</template>

<script>
    export default {
      name: 'ContactUsPage'
    }
</script>